import { Ref } from "vue";
import AuthManager from "~/code/auth-manager";
import { OnibiPortalUserDto } from "~/generated/models/onibi-user-dto";

export function useAuthStore() {
  const authManager = AuthManager.getInstance();

  return {
    get user(): Ref<OnibiPortalUserDto> {
      return authManager.user;
    },
    get authenticated(): Ref<boolean> {
      return authManager.authenticated;
    },
    get loading(): Ref<boolean> {
      return authManager.loading;
    },
    login: authManager.login.bind(authManager),
    logout: authManager.logout.bind(authManager),
    forgotPassword: authManager.forgotPassword.bind(authManager),
    resetPassword: authManager.resetPassword.bind(authManager),
  };
}
